import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Account } from '../../models/account.model';

@Component({
    selector: 'app-trend',
    templateUrl: './trend.component.html',
    styleUrls: ['./trend.component.scss'],
    standalone: false
})

export class TrendComponent implements OnInit {

  constructor() {}

    setDiversionColor(percent) {
      switch (true) {
        case percent < .25:
          return 'red';
        case percent >= .25 && percent <= .50:
          return 'orange';
        case percent >= .50:
          return 'green';
        case percent != null:
          return 'gray';
      }
    }

  ngOnInit() {
  }

  public get accounts() {
    return [];
  }

}
